// Modules
import React from "react";
import PropTypes from "prop-types";

const Facebook = (props) => {
	const {
		clssName,
		color,
	} = props;

	return (
		<svg
			width="17"
			height="34"
			viewBox="0 0 17 34"
			xmlns="http://www.w3.org/2000/svg"
			className={clssName}
		>
			<path
				d="M13.8964 5.6452H17V0.239727C16.4648 0.166016 14.6228 0 12.4788 0C8.00332 0 4.93825 2.81496 4.93825 7.98867V12.75H0V18.7936H4.93825V34H10.9927V18.795H15.7311L16.4834 12.7513H10.9914V8.58766C10.9927 6.84117 11.4628 5.6452 13.8964 5.6452Z"
				fill={color}
			/>
		</svg>
	);
};

Facebook.propTypes = {
	color: PropTypes.string,
	clssName: PropTypes.string,
};

Facebook.defaultProps = {
	clssName: "",
	color: "#EEDFD2",
};

export default Facebook;